// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_fn8","cls2":"ReportList-cls2_Ja- ReportList-cls1_fn8"};